import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { brand, navLinks } from "@/mocks/site";

export default function SiteHeader() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const isActive = (to: string) =>
    to === "/" ? pathname === "/" : pathname === to || pathname.startsWith(`${to}/`);

  return (
    <header className="sticky top-0 z-50">
      <div className="hidden md:block bg-foreground-950 text-background-100">
        <div className="w-full px-4 md:px-8 h-9 flex items-center justify-between text-xs">
          <p className="tracking-wide">
            <span className="text-accent-400 font-medium">爆料鉴定所</span>
            <span className="mx-2 text-background-400">/</span>
            {brand.slogan}，把传闻拆成证据再看
          </p>
          <p className="flex items-center gap-4">
            <span className="text-background-300">{brand.updateNote}</span>
            <span className="hidden lg:inline text-background-400">{brand.email}</span>
          </p>
        </div>
      </div>

      <div
        className={`bg-background-50/95 backdrop-blur border-b transition-colors duration-300 ${
          scrolled ? "border-background-300" : "border-background-200"
        }`}
      >
        <div className="w-full px-4 md:px-8 h-16 md:h-[72px] flex items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-3 shrink-0" aria-label={`${brand.name} 首页`}>
            <span className="w-10 h-10 rounded-control bg-primary-500 text-background-50 flex items-center justify-center font-heading text-xl font-bold">
              瓜
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-lg md:text-xl font-bold text-foreground-950 tracking-tight">
                {brand.name}
              </span>
              <span className="hidden sm:block text-[11px] text-foreground-500 mt-1 tracking-widest">
                真假鉴定 · 实锤分析
              </span>
            </span>
          </Link>

          <nav aria-label="主导航" className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`px-3 py-2 text-sm rounded-control transition-colors whitespace-nowrap ${
                  isActive(link.to)
                    ? "text-primary-600 font-medium bg-primary-50"
                    : "text-foreground-700 hover:text-foreground-950 hover:bg-background-100"
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-2 shrink-0">
            <Link
              to="/gossip"
              className="w-9 h-9 flex items-center justify-center rounded-control border border-background-300 text-foreground-700 hover:text-primary-600 hover:border-primary-300 transition-colors"
              aria-label="搜索爆料"
            >
              <i className="ri-search-line"></i>
            </Link>
            <Link
              to="/contact"
              className="px-4 py-2 rounded-control bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              投稿线索
            </Link>
          </div>

          <button
            type="button"
            aria-label={open ? "关闭菜单" : "打开菜单"}
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-control border border-background-300 text-foreground-800"
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
          </button>
        </div>

        {open && (
          <div className="md:hidden border-t border-background-200 bg-background-50">
            <nav aria-label="移动端导航" className="w-full px-4 py-3 flex flex-col">
              {navLinks.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className={`px-3 py-3 text-sm rounded-control ${
                    isActive(link.to)
                      ? "text-primary-600 font-medium bg-primary-50"
                      : "text-foreground-700"
                  }`}
                >
                  {link.label}
                </Link>
              ))}
              <Link
                to="/contact"
                className="mt-2 px-4 py-3 rounded-control bg-primary-500 text-background-50 text-sm font-medium text-center"
              >
                投稿线索
              </Link>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}